export default "<span class=\"sentiment-badge\" [ngClass]=\"'sentiment-' + sentiment\">\n  {{ label }}\n</span>\n"